<template lang="pug">
  .coreTech
    h1(:class="titleAnimation") 核心技术
    p.text(v-show="text") {{ text }}
    div
      .card(v-for="(item, index) in coreTech" :class="[contentAnimation, `animateDelay-${index}`]")
        div
          .logo
            img(:src="item.img" height="64px" width="64px")
          span.title {{ item.title }}
          p {{ item.text }}
  
</template>

<script>
  import Mixin from '../../index'
  export default {
    name: "coreTech",
    mixins: [Mixin],
    props: {coreTech: Array, text: String},
  };
</script>

<style scoped lang="stylus">
  @import "../../index.styl"
  .coreTech {
    VStack(center, center)
    padding 100px 0 50px
    background transparent
    .text {
      text-align center
      margin-top -10px
      margin-bottom 60px
      line-height 26px
      FontSetting("思源黑体")
      font-weight 300
      padding 0 20px
    }
    > div {
      max-width 1200px
      HStack(center, center)
      flex-wrap wrap
      margin-top -20px
    }
    .card {
      height 280px
      width 510px
      margin 20px
      border 1px solid #e4e4e4
      border-radius 8px
      //transition all .3s
      background-color white
      > div {
        z-index 1
        position relative
        padding 40px
        VStack()
        .logo {
          height 64px
          width 64px
          HStack(center, center)
          border-radius 50%
          background-color white
          margin-bottom 20px
        }
        .title {
          FontSetting("思源黑体 CN Regular")
          font-size 24px
          color #202020
        }
        p {
          color #666666
          font-size 16px
          line-height 24px
          FontSetting("思源黑体 CN Normal")
        }
      }
      &::before, &::after {
        background-color white
      }
      &:hover {
        background-color #269bff
        position relative
        overflow hidden
        > div {
          color white
          > div, >span, > p {
            color white
          }
        }
        &::before, &::after {
          content ""
          position absolute
          border-radius 50%
          z-index 0
        }
        &::before {
          height 200px
          width 200px
          background-color #008aff
          top -100px
          left -70px
          
          //animation topLeftMove 5s infinite linear
        }
        &::after {
          background-color rgba(255, 255, 255, .2)
          height 280px
          width 280px
          top -100px
          right -186px
        }
      }
    }
    @media (max-width ipadProScreenWidth, min-width screenWidth) {
      .card {
        max-width calc(50% - 42px)
      }
    }
    @media (max-width screenWidth) {
      padding 50px 0 0
      width 100vw
      margin-bottom -20px
      .text {
        text-align left
        padding 0 20px
      }
      > div {
        width 100%
        VStack(center)
        p {
          width auto
        }
        .card {
          width 75%
          > div {
            padding 20px
          }
        }
      }
    }
  }
  @keyframes topLeftMove{
    30% {
      top -100px
      left -50px
    }
    70% {
      top -50px
      left -100px
    }
    100% {
      top -100px
      left -70px
    }
  }
</style>
